<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 14:00:42
 * @LastEditors: xiaobai
 * @LastEditTime: 2021-06-11 14:15:05
 * @FilePath: /fujian/src/views/project/components/details.vue
-->
<template>
  <div class="details">
    <div class="details_content">
      <div class="details_content_body">
        <div class="el-image product_img">
          <img :src="details.imgUrl" class="el-image__inner">
        </div>
        <p style="margin-top: 30px; text-align: center;" v-html="details.content"></p>
        <div class="news_btn details_btn">
          <span @click="goBack()" class="news_btn_span">返回列表&gt;&gt;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['details'],
  methods:{
    goBack(){
      this.$emit('goback')
    }
  }
}
</script>

<style>
  .details_btn{
    float:inherit;
    margin: 0 auto;
  }
  .details_btn .news_btn_span{
    margin: 0 auto!important;
  } 
</style>